import _ from "lodash";
import { EDIT_FIELD } from "../GridConstants";
import { editStateType } from "./EditStateType";

// eslint-disable-next-line no-extend-native
Array.prototype.withEditfield = function (
  dataItemKey: string,
  editState: editStateType
) {
  return this.map((item) => ({
    ...item,
    [EDIT_FIELD]: _.get(item, dataItemKey) === editState,
  }));
};

export {};
